import cn from 'classnames'
import React, { ComponentProps } from 'react'

type NotificationsNewIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function NotificationsNewIcon(props: NotificationsNewIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('NotificationsNewIcon', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0011 1.98242C13.2263 1.98257 14.251 2.95663 14.2511 4.19629V4.31934C16.8726 5.24611 18.7511 7.74576 18.7511 10.6846V11.4482C18.7512 11.9778 18.9114 12.4953 19.2101 12.9326L21.5519 16.3623C22.3448 17.5237 21.5129 19.0984 20.1066 19.0986H15.674C15.3277 20.7702 13.8475 22.0271 12.0734 22.0273H11.9289C10.1547 22.0272 8.67458 20.7702 8.32827 19.0986H3.89566C2.48909 19.0986 1.65719 17.5238 2.45035 16.3623L4.79214 12.9326C5.0908 12.4953 5.25107 11.9778 5.25113 11.4482V10.6846C5.25113 7.74557 7.12944 5.24596 9.75113 4.31934V4.19629C9.75122 2.95654 10.7758 1.98242 12.0011 1.98242ZM9.88589 19.0986C10.1917 19.9316 10.9899 20.5272 11.9289 20.5273H12.0734C13.0123 20.5271 13.8106 19.9316 14.1164 19.0986H9.88589ZM12.0011 5.43457C9.10163 5.43457 6.75113 7.78508 6.75113 10.6846V11.4482C6.75107 12.2796 6.50025 13.0918 6.0314 13.7783L3.68863 17.208C3.57544 17.3739 3.69476 17.5986 3.89566 17.5986H20.1066C20.3072 17.5984 20.4265 17.3738 20.3136 17.208L17.9709 13.7783C17.502 13.0918 17.2512 12.2796 17.2511 11.4482V10.6846C17.2511 7.78517 14.9005 5.43473 12.0011 5.43457ZM12.0011 3.48242C11.674 3.48242 11.4125 3.67647 11.3048 3.93457H12.6974C12.5898 3.6765 12.3282 3.48253 12.0011 3.48242Z"
        fill={props.fill || '#4489F9'}
      />
    </svg>
  )
}
